module.exports = __webpack_public_path__ + "img/test2.37f40afe.jpg";